module.exports = __webpack_public_path__ + "img/1557251718.bc684612.jpg";